<template>
  <div class="user-center">
    <!-- <div class="h-top">
        <home-top :left="true" :logo="false" class="ceiling"></home-top>
    </div> -->
    <div class="content">
      <div class="nav">
        <!-- 头部logo -->
        <div class="logo-word hit-cursor" @click="goToHome">
          <img class="logo-big" src="../../static/index/hualianwang.png"/>
        </div>
        <!-- 导航栏 -->
        <div class="nav-list">
          <el-menu :default-active="activeRoute" router :collapse="false" @open="handleOpen"
                   text-color="#00112b"
                   active-text-color="#E60A0C"
                   :default-openeds="['3', '4', '5', '6', '7', '8']" :openeds="openeds">
            <el-menu-item index="/user/user-center" class="user-title">
              <i class="el-icon-user-solid user-icon"></i>
              <!--              <img class="nav-icon" src="../../static/user/nav/nav-icon-0.png" alt="首页"/>-->
              <span slot="title" class="word-size">个人中心</span>
            </el-menu-item>
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-s-cooperation color-blue"></i>
                <!--                <img class="nav-icon" src="../../static/user/nav/nav-icon-1.png" alt="首页"/>-->
                <span class="word-size">我是采购商</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/user/purchase/release" class="word-size">
                  发布询单
                </el-menu-item>
                <el-menu-item index="/user/purchase/post" class="word-size">
                  询单管理
                  <span class="color-doat" v-if="user_count.quoteNotReadCount">
                      {{ user_count.quoteNotReadCount || 0 }}
                    </span>
                </el-menu-item>
                <el-menu-item index="/user/purchase/order" class="word-size">
                  成交订单
                  <span class="color-doat" v-if="user_count.purchaseOrderCount">
                      {{ user_count.purchaseOrderCount || 0 }}
                    </span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-s-shop color-blue"></i>
                <!--                <img class="nav-icon" src="../../static/user/nav/nav-icon-2.png" alt="首页"/>-->
                <span class="word-size">我是供应商/工厂</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/user/supplier/my-project" class="word-size">我的产品</el-menu-item>
                <el-menu-item index="/user/supplier/quotation" class="word-size">
                  <template>
                    报价管理
                    <span class="color-doat" v-if="user_count.quote_count">
                      {{ user_count.quote_count || 0 }}
                    </span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user/supplier/sale-order" class="word-size">销售订单
                  <span class="color-doat" v-if="user_count.supplyOrderCount">
                      {{ user_count.supplyOrderCount || 0 }}
                    </span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">
                <i class="el-icon-s-opportunity color-blue"></i>
                <!--                <img class="nav-icon" src="../../static/user/nav/nav-icon-3.png" alt="首页"/>-->
                <span class="word-size">技术项目交易</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/user/technology" class="word-size">技术供需管理</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="6">
              <template slot="title">
                <i class="el-icon-s-data color-blue"></i>
                <!--                <img class="nav-icon" src="../../static/user/nav/nav-icon-4.png" alt="首页"/>-->
                <span class="word-size">来料加工</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/user/process" class="word-size">加工供需管理</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="7">
              <template slot="title">
                <i class="el-icon-s-comment color-blue"></i>
                <span class="word-size">消息中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/user/message/mail" class="word-size">站内信
                  <span class="color-doat" v-if="user_message_count">
                    {{ user_message_count || 0 }}
                  </span></el-menu-item>
                <el-menu-item index="/user/message/message-counter" class="word-size">推送设置</el-menu-item>
                <el-menu-item index="/user/message/complaint" class="word-size">
                  投诉建议
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="8">
              <template slot="title">
                <i class="el-icon-s-custom color-blue"></i>
                <!--                <img class="nav-icon" src="../../static/user/nav/nav-icon-6.png" alt="首页"/>-->
                <span class="word-size">账号管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/user/base-info">
                  <span class="word-size"> 基本资料</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <!-- 右侧身体 -->
      <div class="body">
        <div class="user-info">
          <div class="user-info-content">
            <div class="vip-status-container">
              <div class="backHome" @click="goToHome">
                <i class="el-icon-house"></i>
                网站首页
              </div>
              <!-- VIP充值入口 -->
              <vip-status></vip-status>
            </div>
            <!-- 用户头像和下拉菜单 -->
            <div class="user-name">
              <div class="bog-name" v-if="userInfo.realname">
                {{ userInfo.realname }}
              </div>
              <div class="bog-name" v-else>{{ $utils.maskPhoneNumber(userInfo.mobile) }}</div>
              <div class="mini-com">{{ userInfo.company || "--" }}</div>
            </div>
            <div class="avatar-dropdown">
              <div class="avater" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                <img :src="userInfo.avatar" alt="用户头像">
              </div>
              <img v-if="userInfo.vip_status == 1" class="user-vip" src="../../static/vip/VipVip.png" alt="vip">
              <div class="dropdown-menu" v-if="showDropdown" @mouseenter="handleMouseEnter"
                   @mouseleave="handleMouseLeave">
                <div class="dropdown-item" @click="goToHome">
                  <i class="el-icon-house"></i>
                  <span>网站首页</span>
                </div>
                <div class="dropdown-divider"></div>
                <div class="dropdown-item" @click="logout">
                  <i class="el-icon-switch-button"></i>
                  <span>退出登录</span>
                </div>
              </div>
            </div>


          </div>
          <el-tabs type="card" :value="activeName" @tab-remove="handleTabsRemove" @tab-click="handleTabsClick">
            <el-tab-pane v-for="item in routeList" :key="item.path" :label="item.title" :name="item.title"
                         :closable="item.title != '个人中心' ? true : false" @contextmenu="handleRightClick">
              <div class="body-content">
                <router-view v-if="activeTab === item.path"></router-view>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <customer></customer>
  </div>
</template>
<script>
import homeTop from "../../components/public/home-top.vue";
import customer from "../../components/customer.vue";
import {mapGetters} from "vuex";
import {getUserStatistics} from "@/api/modules/common";
import VipStatus from "../../components/vip/vipStatus.vue";

export default {
  name: "user",
  components: {
    VipStatus,
    homeTop,
    customer,
  },
  data() {
    return {
      // 添加默认展开的菜单项索引
      openeds: ['3', '4', '5', '6', '7', '8'],
      showDropdown: false,
      dropdownTimer: null, // 添加定时器
      closable: true,
      rightClickListenerAdded: false, // 标记是否已添加右击监听器
      rightClickTimer: null, // 右击防抖定时器
      isLoading: false, // 返回首页按钮加载状态
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    ...mapGetters(["isLogin", 'user_count', 'is_vip', 'user_message_count']),
    activeRoute() {
      return this.$route.path;
    },
    // 从 Vuex 获取标签页列表
    routeList() {
      return this.$store.getters["router/tabs"];
    },
    // 从 Vuex 获取当前激活的标签（使用路由path）
    activeTab() {
      return this.$store.getters["router/activeTab"];
    },
    // 标签导航使用的激活名称（使用导航栏标题）
    activeName: {
      get() {
        const activeTitle = this.$store.getters["router/activeTabTitle"];
        return activeTitle;
      },
      set(val) {
        this.$store.commit('router/SET_ACTIVE_TAB_TITLE', val)
      }
    },
    // 获取当前路由的子页面
    childRoutes() {
      return this.$store.getters["router/getChildRoutes"](this.$route.path);
    },
  },
  watch: {
    // 监听路由变化，自动更新激活的标签
    $route: {
      handler(to, from) {
        // 更新激活的标签页路径
        this.$store.commit('router/SET_ACTIVE_TAB', to.path);

        // 查找对应的标签并设置标题
        const currentTab = this.routeList.find(tab => tab.path === to.path);
        if (currentTab) {
          this.$store.commit('router/SET_ACTIVE_TAB_TITLE', currentTab.title);
        } else {
          // 如果标签页列表中没有该路由，需要从路由元信息中获取标题并添加标签页
          const routeTitle = to.meta?.title || to.name || '未知页面';
          const newTab = {
            path: to.path,
            name: to.name,
            title: routeTitle,
            meta: to.meta || {}
          };

          // 添加到标签页列表
          this.$store.commit('router/ADD_TAB', newTab);
          this.$store.commit('router/SET_ACTIVE_TAB_TITLE', routeTitle);
        }
      },
      immediate: true // 立即执行一次
    }
  },
  mounted() {
    this.$store.dispatch('GET_USER_COUNT');
    // 避免重复导航错误，重定向到用户中心首页
    if (this.$route.path === "/user/index") {
      this.$router.replace("/user/user-center").catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      });
      return; // 重定向后直接返回，不需要后续的状态设置
    }

    // 初始化默认首页标签（如果标签页列表为空）
    if (this.routeList.length === 0) {
      const homeTab = {
        path: '/user/user-center',
        name: 'user-center',
        title: '个人中心',
        meta: {title: '个人中心', login: true}
      };
      this.$store.commit('router/ADD_TAB', homeTab);
    }

    // 设置当前激活的标签为当前路由路径
    this.$store.commit('router/SET_ACTIVE_TAB', this.$route.path);

    // 查找当前路由对应的标签页并设置标题
    const current = this.routeList.find(t => t.path === this.$route.path);
    if (current) {
      this.$store.commit('router/SET_ACTIVE_TAB_TITLE', current.title);
    } else {
      // 如果当前路由不在标签页列表中，添加它
      const routeTitle = this.$route.meta?.title || this.$route.name || '未知页面';
      const newTab = {
        path: this.$route.path,
        name: this.$route.name,
        title: routeTitle,
        meta: this.$route.meta || {}
      };
      this.$store.commit('router/ADD_TAB', newTab);
      this.$store.commit('router/SET_ACTIVE_TAB_TITLE', routeTitle);
    }

    this.addRightClickListener();

    // 确保菜单默认展开 - 使用多种方式确保生效
    this.$nextTick(() => {
      // 方式1：直接设置openeds
      this.openeds = ['3', '4', '5', '6', '7', '8'];

      // 方式2：强制触发菜单展开
      setTimeout(() => {
        this.forceExpandMenus();
        // 手动触发每个子菜单的展开
        const submenus = document.querySelectorAll('.el-submenu');
        submenus.forEach(submenu => {
          const index = submenu.getAttribute('index');
          if (['3', '4', '5', '6', '7', '8'].includes(index)) {
            submenu.classList.add('is-opened');
          }
        });
      }, 100);
    });
  },
  methods: {
    // 添加右击事件监听器
    addRightClickListener() {
      // 避免重复绑定
      if (!this.rightClickListenerAdded) {
        // 使用事件委托，只在特定区域监听
        const tabsContainer = document.querySelector(".el-tabs__header");
        if (tabsContainer) {
          tabsContainer.addEventListener("contextmenu", this.handleRightClick);
          this.rightClickListenerAdded = true;
        }
      }
    },
    handleRightClick(event) {
      // 直接处理，不使用防抖
      const targetElement = event.target;
      const tabsNavWrap = targetElement.closest(".el-tabs__item");

      if (tabsNavWrap) {
        event.preventDefault();
        event.stopPropagation(); // 阻止事件冒泡
        // 可以在这里添加你的自定义逻辑
        this.handleTabsRightClick(event, tabsNavWrap);
      }
    },
    handleOpen(key, keyPath) {
      if (key == 7) {
        this.$store.dispatch('GET_USER_MESSAGE_COUNT');
      }
    },

    // 强制展开所有菜单
    forceExpandMenus() {
      this.openeds = ['3', '4', '5', '6', '7', '8'];
      this.$forceUpdate();
    },

    // 处理标签页右击的具体逻辑
    handleTabsRightClick(event, tabsNavWrap) {
      // 获取鼠标位置
      const x = event.clientX;
      const y = event.clientY;

      // 显示自定义右键菜单
      this.showTabsContextMenu(x, y, tabsNavWrap);
    },

    // 显示标签页右键菜单
    showTabsContextMenu(x, y, tabsNavWrap) {
      // 移除已存在的菜单
      const existingMenu = document.querySelector(".tabs-context-menu");
      if (existingMenu) {
        document.body.removeChild(existingMenu);
      }

      // 创建菜单容器
      const menu = document.createElement("div");
      menu.className = "tabs-context-menu";

      // 计算菜单位置，避免超出屏幕边界
      const menuWidth = 140;
      const menuHeight = 80; // 预估高度
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // 调整X坐标，确保菜单不超出右边界
      let adjustedX = x;
      if (x + menuWidth > windowWidth) {
        adjustedX = windowWidth - menuWidth - 10;
      }

      // 调整Y坐标，确保菜单不超出下边界
      let adjustedY = y;
      if (y + menuHeight > windowHeight) {
        adjustedY = windowHeight - menuHeight - 10;
      }

      menu.style.cssText = `
        position: fixed;
        left: ${adjustedX}px;
        top: ${adjustedY}px;
        background: white;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        z-index: 10000;
        padding: 4px 0;
        min-width: ${menuWidth}px;
        font-size: 14px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      `;

      // 菜单选项
      const menuItems = [
        {
          text: "关闭当前标签栏",
          action: () => this.closeCurrentTab(tabsNavWrap),
        },
        {
          text: "关闭所有标签栏",
          action: () => this.closeAllTabs(),
        },
      ];

      // 创建菜单项
      menuItems.forEach((item) => {
        const menuItem = document.createElement("div");
        menuItem.textContent = item.text;
        menuItem.style.cssText = `
          padding: 8px 16px;
          cursor: pointer;
          color: #606266;
          transition: all 0.2s ease;
          user-select: none;
          border-bottom: 1px solid #f0f0f0;
        `;

        // 最后一个菜单项不需要底部边框
        if (menuItems.indexOf(item) === menuItems.length - 1) {
          menuItem.style.borderBottom = "none";
        }

        // 鼠标悬停效果
        menuItem.onmouseover = () => {
          menuItem.style.backgroundColor = "#f5f7fa";
          menuItem.style.color = "#409eff";
        };

        menuItem.onmouseout = () => {
          menuItem.style.backgroundColor = "white";
          menuItem.style.color = "#606266";
        };

        // 点击事件
        menuItem.onclick = () => {
          item.action();
          document.body.removeChild(menu);
        };

        menu.appendChild(menuItem);
      });

      // 添加到页面
      document.body.appendChild(menu);

      // 点击其他地方关闭菜单
      const closeMenu = (e) => {
        if (!menu.contains(e.target)) {
          if (document.body.contains(menu)) {
            document.body.removeChild(menu);
          }
          document.removeEventListener("click", closeMenu);
        }
      };

      // 延迟添加点击事件，避免立即触发
      setTimeout(() => {
        document.addEventListener("click", closeMenu);

        // 添加ESC键关闭菜单
        const closeOnEsc = (e) => {
          if (e.key === "Escape") {
            if (document.body.contains(menu)) {
              document.body.removeChild(menu);
            }
            document.removeEventListener("keydown", closeOnEsc);
          }
        };
        document.addEventListener("keydown", closeOnEsc);
      }, 100);
    },

    // 关闭当前标签栏
    closeCurrentTab(tabsNavWrap) {
      // 获取当前标签页的名称
      const currentTabName = this.activeTab;

      if (currentTabName && currentTabName !== "/user/user-center") {
        // 显示确认对话框
        this.$confirm("确定要关闭当前标签栏吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(() => {
              // 关闭当前标签页
              this.$store.dispatch("router/closeTab", currentTabName);
              this.$message.success("已关闭当前标签栏");
            })
            .catch(() => {
              // 用户取消操作
            });
      } else {
        this.$message.warning("首页标签栏不能关闭");
      }
    },

    // 关闭所有标签栏
    closeAllTabs() {
      // 获取所有标签页
      const allTabs = this.routeList;
      const closeableTabs = allTabs.filter(
          (tab) => tab.path !== "/user/user-center"
      );

      if (closeableTabs.length === 0) {
        this.$message.warning("没有可关闭的标签栏");
        return;
      }

      // 显示确认对话框
      this.$confirm(
          `确定要关闭所有标签栏吗？(共${closeableTabs.length}个)`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      )
          .then(() => {
            // 关闭除首页外的所有标签页
            closeableTabs.forEach((tab) => {
              this.$store.dispatch("router/closeTab", tab.path);
            });
            this.$message.success(`已关闭${closeableTabs.length}个标签栏`);
          })
          .catch(() => {
            // 用户取消操作
          });
    },
    handleTabsClick(tab, event) {
      if (tab.name === "首页") {
        this.closable = false;
      } else {
        this.closable = true;
      }

      // 将标签名(标题)映射为路由path
      const found = this.routeList.find(r => r.title === tab.name);
      if (found) {
        const targetPath = found.path;

        // 更新Vuex状态
        this.$store.commit('router/SET_ACTIVE_TAB', targetPath);
        this.$store.commit('router/SET_ACTIVE_TAB_TITLE', tab.name);

        // 如果当前路由不是目标路由，则进行路由跳转
        if (this.$route.path !== targetPath) {
          this.$router.push(targetPath).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              console.error('路由跳转失败:', err);
            }
          });
        }
      }
    },
    handleTabsRemove(targetName) {
      // 将标签名(标题)映射为路由path再关闭
      const found = this.routeList.find(r => r.title === targetName)
      const targetPath = found ? found.path : targetName;
      this.$store.dispatch("router/closeTab", targetPath);
    },
    handleMouseEnter() {
      if (this.dropdownTimer) {
        clearTimeout(this.dropdownTimer);
      }
      this.showDropdown = true;
    },
    handleMouseLeave() {
      if (this.dropdownTimer) {
        clearTimeout(this.dropdownTimer);
      }
      this.dropdownTimer = setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },
    goToHome() {
      // 设置加载状态
      this.isLoading = true;

      // 使用 Vuex 导航到首页
      this.$router.push("/").then(() => {
        // 导航成功后刷新加载状态
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }).catch(() => {
        // 导航失败时也刷新加载状态
        this.isLoading = false;
      });
    },
    logout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$utils.logout(this.$store, this.$router);
            this.$message.success("已退出登录");
          })
          .catch(() => {
            // 用户取消退出
          });
    },

  },
  beforeDestroy() {
    // 清理定时器
    if (this.dropdownTimer) {
      clearTimeout(this.dropdownTimer);
    }
    if (this.rightClickTimer) {
      clearTimeout(this.rightClickTimer);
    }
    // 清理事件监听器
    const tabsContainer = document.querySelector(".el-tabs__header");
    if (tabsContainer) {
      tabsContainer.removeEventListener("contextmenu", this.handleRightClick);
    }
  },
};
</script>
<style lang="scss" scoped>
.user-title {
  color: #ffffff !important;
  font-weight: bold;
  background: linear-gradient(135deg, #2f67ff 0%, #4facfe 100%);

  .user-icon {
    color: #FFFFFF;
  }
}

.color-blue {
  color: #4f94ff;
}

.vip-status-container {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
}

.user-vip {
  position: absolute;
  right: 0;
  transform: translateY(-80%);
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.word-size {
  font-size: 15px !important;
}

.color-doat {
  display: inline-block;
  color: #ffffff;
  background: red;
  width: 17px;
  height: 17px;
  line-height: 17px;
  font-size: 11px;
  border-radius: 50%;
  text-align: center;
  transform: translateY(-80%);
}

::v-deep {
  .el-tabs__header {
    background: #ffffff;
    border-top: 1px solid #e4e7ed;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: none;
    background: #fcfcfc;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: rgb(230 10 12);
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item {
    border-left: none;
  }

  .el-tabs__item.is-active {
    font-weight: 500;
    color: rgb(230 10 12) !important;
    background: #ffffff !important;
    border-bottom-color: #ffffff !important;
    position: relative;
  }

  .el-tabs__item.is-active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: rgb(230 10 12);
  }

  .el-tabs__content {
    height: calc(100vh - 160px);
    overflow: hidden;
  }

  .el-tab-pane {
    height: 100%;
  }
}

.el-menu-item {
  padding-left: 30px;
}

.nav-icon {
  width: 16px;
  height: 16px;
  margin-right: 30px;
}

.user-center {
  width: 100%;
  height: 100%;

  .h-top {
    display: flex;
    height: 62px;
  }

  .content {
    display: flex;

    .nav {
      position: fixed;
      width: 240px;
      height: 100vh;
      background: #ffffff;
      box-shadow: 5px 0px 6px 1px rgba(0, 0, 0, 0.02);
      border-radius: 0px 0px 0px 0px;

      .logo-word {
        padding: 40px 30px;
        display: flex;
        color: #000000;
        align-items: center;
        //margin-right: 32px;

        .logo-big {
          width: 150px;
          height: 50px;
          object-fit: contain;
        }

        .word-big {
          margin-left: 10px;

          .china-word {
            white-space: nowrap;
            font-size: 22px;
            color: #00112b;
            font-weight: 700;
          }

          .english-word {
            white-space: nowrap;
            font-size: 11px;
            color: #afafaf;
          }
        }
      }

      .nav-list {
        height: calc(100% - 134px);
        /* 减去logo区域的高度 */
        overflow-y: auto;
      }
    }

    .body {
      margin-left: 240px;
      width: calc(100% - 240px);
      height: 100vh;
      display: flex;
      flex-direction: column;
      box-shadow: 5px 0px 6px 1px rgba(0, 0, 0, 0.02);
      border-radius: 0px 0px 0px 0px;

      .user-info-height {
        height: 80px;
      }

      .user-info {
        position: fixed;
        right: 0;
        width: calc(100% - 240px);
        height: 80px;
        background: #ffffff;
        box-shadow: 0px 3px 12px 1px rgba(25, 25, 70, 0.06);
        border-radius: 0px 0px 0px 0px;
        z-index: 99;

        .user-info-content {
          display: flex;
          width: 93%;
          align-items: center;
          justify-content: space-between;
          padding: 15px 0 5px;
          background: #ffffff;

          .backHome {
            color: #5f616c;
            padding-left: 12px;
            font-size: 16px;
            cursor: pointer;
          }

          @media (max-width: 768px) {
            flex-direction: column;
            align-items: stretch;
            padding: 16px;
            gap: 16px;
          }

          // 返回首页按钮样式
          .return-home {
            background: linear-gradient(135deg, #4facfe 0%, #2f67ff 100%);
            border: none;
            color: white;
            padding: 12px 24px;
            border-radius: 10px;
            font-weight: 600;
            font-size: 14px;
            box-shadow: 0 4px 15px rgba(79, 172, 254, 0.3);
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            overflow: hidden;
            margin-right: 20px;
            display: flex;
            align-items: center;
            gap: 8px;
            animation: slideInFromLeft 0.6s ease-out;

            @media (max-width: 768px) {
              padding: 10px 20px;
              font-size: 13px;
              margin-right: 0;
              margin-bottom: 10px;
              gap: 6px;
            }

            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
              transition: left 0.5s;
            }

            &::after {
              content: '';
              position: absolute;
              top: 50%;
              left: 50%;
              width: 0;
              height: 0;
              background: rgba(255, 255, 255, 0.3);
              border-radius: 50%;
              transform: translate(-50%, -50%);
              transition: width 0.6s, height 0.6s;
            }

            &:hover {
              transform: translateY(-3px);
              box-shadow: 0 12px 30px rgba(79, 172, 254, 0.4), 0 0 0 3px rgba(79, 172, 254, 0.1);

              &::before {
                left: 100%;
              }

              &::after {
                width: 300px;
                height: 300px;
              }
            }

            &:active {
              transform: translateY(-1px);
              box-shadow: 0 6px 20px rgba(79, 172, 254, 0.3);

              &::after {
                width: 0;
                height: 0;
                transition: width 0.1s, height 0.1s;
              }
            }

            i {
              font-size: 18px;
              color: #ffd700;
              transition: all 0.3s ease;
              z-index: 1;
              position: relative;

              @media (max-width: 768px) {
                font-size: 16px;
              }
            }

            span {
              z-index: 1;
              position: relative;
              transition: all 0.3s ease;
            }

            &:hover i {
              transform: scale(1.2) rotate(5deg);
              color: #fff;
            }

            &:hover span {
              transform: translateX(2px);
            }

            // 脉冲动画
            @keyframes pulse {
              0% {
                box-shadow: 0 4px 15px rgba(79, 172, 254, 0.3);
              }

              50% {
                box-shadow: 0 4px 15px rgba(79, 172, 254, 0.6), 0 0 0 10px rgba(79, 172, 254, 0.1);
              }

              100% {
                box-shadow: 0 4px 15px rgba(79, 172, 254, 0.3);
              }
            }

            &:hover {
              animation: pulse 2s infinite;
            }

            // 加载状态样式
            &.is-loading {
              background: linear-gradient(135deg, #4ad4de 0%, #223bc5 100%);
              cursor: not-allowed;

              &:hover {
                transform: none;
                box-shadow: 0 4px 15px rgba(79, 172, 254, 0.3);
                animation: none;
              }

              &::before,
              &::after {
                display: none;
              }
            }

            // 进入动画
            @keyframes slideInFromLeft {
              0% {
                opacity: 0;
                transform: translateX(-30px) scale(0.8);
              }

              50% {
                opacity: 0.7;
                transform: translateX(-10px) scale(0.9);
              }

              100% {
                opacity: 1;
                transform: translateX(0) scale(1);
              }
            }
          }

          // VIP充值入口样式
          .vip-recharge-section {
            flex: 1;
            margin-right: 20px;
            display: flex;
            justify-content: flex-end;

            @media (max-width: 768px) {
              margin-right: 0;
              order: 1;
            }

            .vip-card {
              background: linear-gradient(135deg, #2f67ff 0%, #4facfe 100%);
              border-radius: 10px;
              padding: 10px 20px;
              color: white;
              box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
              transition: all 0.3s ease;
              position: relative;
              right: 0;
              overflow: hidden;

              @media (max-width: 768px) {
                padding: 16px;
              }

              &::before {
                content: '';
                position: absolute;
                top: -50%;
                right: -50%;
                width: 200%;
                height: 200%;
                background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
                animation: shimmer 3s infinite;
              }

              @keyframes shimmer {
                0% {
                  transform: rotate(0deg);
                }

                100% {
                  transform: rotate(360deg);
                }
              }

              &:hover {
                transform: translateY(-4px);
                box-shadow: 0 12px 40px rgba(102, 126, 234, 0.4);
              }

              .vip-card-header {
                display: flex;
                align-items: center;

                @media (max-width: 768px) {
                  margin-bottom: 16px;
                }

                .vip-icon {
                  background: rgba(255, 255, 255, 0.2);
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 16px;

                  @media (max-width: 768px) {
                    width: 40px;
                    height: 40px;
                    margin-right: 12px;
                  }

                  i {
                    font-size: 24px;
                    color: #ffd700;

                    @media (max-width: 768px) {
                      font-size: 20px;
                    }
                  }
                }

                .vip-title {
                  display: flex;
                  white-space: nowrap;
                  align-items: center;

                  h3 {
                    margin: 0 0 4px 0;
                    font-size: 14px;
                    font-weight: 600;
                    color: white;
                    margin-right: 5px;

                    @media (max-width: 768px) {
                      font-size: 14px;
                    }
                  }

                  p {
                    margin: 0;
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.8);

                    @media (max-width: 768px) {
                      font-size: 12px;
                    }
                  }
                }
              }

              .vip-card-content {
                .vip-benefits {
                  margin-bottom: 20px;

                  @media (max-width: 768px) {
                    margin-bottom: 16px;
                  }

                  .benefit-item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 8px;
                    font-size: 14px;

                    @media (max-width: 768px) {
                      font-size: 12px;
                      margin-bottom: 6px;
                    }

                    i {
                      color: #4ade80;
                      margin-right: 8px;
                      font-size: 16px;

                      @media (max-width: 768px) {
                        font-size: 14px;
                        margin-right: 6px;
                      }
                    }

                    span {
                      color: rgba(255, 255, 255, 0.9);
                    }
                  }
                }

                .vip-action {
                  .vip-upgrade-btn {
                    background: linear-gradient(45deg, #ffd700, #ffed4e);
                    border: none;
                    color: #333;
                    font-weight: 600;
                    padding: 12px 24px;
                    border-radius: 8px;
                    transition: all 0.3s ease;

                    @media (max-width: 768px) {
                      padding: 10px 20px;
                      font-size: 14px;
                    }

                    i {
                      margin-right: 6px;
                      color: #333;
                    }

                    &:hover {
                      transform: translateY(-2px);
                      box-shadow: 0 6px 20px rgba(255, 215, 0, 0.4);
                    }
                  }
                }
              }
            }


          }

          .avatar-dropdown {
            float: right;
            position: relative;

            @media (max-width: 768px) {
              float: none;
              align-self: center;
              order: 2;
            }

            .avater {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              margin-left: 20px;
              cursor: pointer;
              transition: all 0.3s ease;

              @media (max-width: 768px) {
                margin-left: 0;
              }

              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }

              &:hover {
                transform: scale(1.05);
                box-shadow: 0 4px 12px rgba(12, 96, 230, 0.3);
              }
            }

            .dropdown-menu {
              position: absolute;
              right: 0;
              top: 60px;
              background: #ffffff;
              border-radius: 8px;
              box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
              padding: 8px 0;
              min-width: 140px;
              z-index: 1000;
              border: 1px solid #e4e7ed;
              animation: dropdownFadeIn 0.2s ease-out;

              @media (max-width: 768px) {
                right: auto;
                left: 50%;
                transform: translateX(-50%);
              }

              @keyframes dropdownFadeIn {
                from {
                  opacity: 0;
                  transform: translateY(-10px);
                }

                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }

              .dropdown-item {
                display: flex;
                align-items: center;
                padding: 12px 16px;
                cursor: pointer;
                transition: all 0.2s ease;
                color: #333;
                font-size: 14px;

                i {
                  margin-right: 8px;
                  font-size: 16px;
                  color: #666;
                }

                &:hover {
                  background: #f5f7fa;
                  color: #0c60e6;

                  i {
                    color: #0c60e6;
                  }
                }

                &:first-child {
                  border-radius: 8px 8px 0 0;
                }

                &:last-child {
                  border-radius: 0 0 8px 8px;
                }
              }

              .dropdown-divider {
                height: 1px;
                background: #e4e7ed;
                margin: 4px 0;
              }
            }
          }

          .user-name {
            float: right;
            text-align: right;

            @media (max-width: 768px) {
              float: none;
              text-align: center;
              order: 3;
            }

            .bog-name {
              font-weight: bold;
              font-size: 16px;
              color: #00112b;
              line-height: 22px;

              @media (max-width: 768px) {
                font-size: 14px;
              }
            }

            .mini-com {
              padding-top: 5px;
              font-weight: 500;
              font-size: 14px;
              color: #5f616c;

              @media (max-width: 768px) {
                font-size: 12px;
                padding-top: 3px;
              }
            }
          }
        }
      }

      .body-content {
        flex: 1;
        overflow-y: auto;
        width: 100%;
        height: 100%;
        padding: 20px 20px 100px 20px;
        background: #f5f5f5;
        box-sizing: border-box;
      }
    }
  }
}

//::v-deep .el-menu .el-submenu__title {
//  background: #F5F5F5 !important;
//}
::v-deep .el-menu-item-group__title {
  padding: 0 !important;
}

::v-deep .el-submenu__title {
  background: #e2efff !important;
  //color: #fff !important;
}

</style>
